import {
  ShieldCheck, Lock, ReceiptText, Database, KeyRound, ShieldHalf,
} from "lucide-react";

const METHODS = ["UPI", "Credit Cards", "Debit Cards", "Net Banking", "Wallets"];

// Pricing page — full secure-payments bar with accepted methods
export const RazorpaySecureBar = ({ className = "" }) => (
  <div
    className={`flex flex-col items-center gap-4 rounded-none border border-slate-200 bg-white px-6 py-6 ${className}`}
    data-testid="razorpay-secure-bar"
  >
    <div className="flex items-center gap-2.5">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0B3D91]/10">
        <ShieldCheck className="h-5 w-5 text-[#0B3D91]" />
      </span>
      <span className="text-base font-bold text-slate-900">
        Secure Payments Powered by <span className="text-[#0B3D91]">Razorpay</span>
      </span>
    </div>
    <div className="flex flex-wrap items-center justify-center gap-2">
      {METHODS.map((m) => (
        <span
          key={m}
          className="inline-flex items-center rounded-none border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-semibold text-slate-700"
          data-testid={`pay-method-${m.toLowerCase().replace(/\s+/g, "-")}`}
        >
          {m}
        </span>
      ))}
    </div>
  </div>
);

// Checkout — concise "100% Secure" note
export const CheckoutSecureNote = ({ className = "" }) => (
  <div
    className={`flex flex-col items-center gap-1 rounded-sm border border-border bg-secondary/40 px-4 py-3 text-center ${className}`}
    data-testid="checkout-secure-note"
  >
    <div className="inline-flex items-center gap-1.5 text-sm font-bold text-[#0B3D91]">
      <Lock className="h-4 w-4" /> 100% Secure Payments
    </div>
    <div className="text-xs font-semibold text-muted-foreground">Powered by Razorpay</div>
    <div className="text-[11px] text-muted-foreground">Your payment information is processed securely.</div>
  </div>
);

// Billing page — secured-by note + GST invoice assurance
export const BillingSecureNote = ({ className = "" }) => (
  <div
    className={`flex flex-wrap items-center gap-x-6 gap-y-2 rounded-sm border border-border bg-secondary/40 px-4 py-3 ${className}`}
    data-testid="billing-secure-note"
  >
    <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-foreground">
      <ShieldCheck className="h-4 w-4 text-[#0B3D91]" /> Payments secured by Razorpay
    </span>
    <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-foreground">
      <ReceiptText className="h-4 w-4 text-[#16A34A]" /> GST Invoice available for every payment
    </span>
  </div>
);

const TRUST_ITEMS = [
  { icon: Lock, label: "Secure Payments" },
  { icon: ReceiptText, label: "GST Invoices" },
  { icon: ShieldCheck, label: "SSL Secured Platform" },
  { icon: Database, label: "Multi-Tenant Data Isolation" },
  { icon: KeyRound, label: "Role-Based Access" },
  { icon: ShieldHalf, label: "Data Ownership Protection" },
];

// Trust section — six security assurances
export const TrustSection = ({ className = "" }) => (  <div
    className={`grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6 ${className}`}
    data-testid="trust-section"
  >
    {TRUST_ITEMS.map(({ icon: Icon, label }) => (
      <div
        key={label}
        className="flex flex-col items-center gap-2 rounded-none border border-slate-200 bg-white px-3 py-5 text-center"
        data-testid={`trust-item-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#16A34A]/10">
          <Icon className="h-5 w-5 text-[#16A34A]" />
        </span>
        <span className="text-xs font-semibold leading-snug text-slate-800">{label}</span>
      </div>
    ))}
  </div>
);


// Compact inline trust row — for conversion points (e.g. Signup)
const COMPACT_ITEMS = [
  { icon: Lock, label: "Secure Payments" },
  { icon: ReceiptText, label: "GST Invoices" },
  { icon: ShieldCheck, label: "SSL Secured" },
];

export const CompactTrustRow = ({ className = "" }) => (
  <div
    className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 ${className}`}
    data-testid="compact-trust-row"
  >
    {COMPACT_ITEMS.map(({ icon: Icon, label }, i) => (
      <span key={label} className="flex items-center gap-2">
        {i > 0 && <span className="text-slate-300">·</span>}
        <span
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-600"
          data-testid={`compact-trust-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          <Icon className="h-3.5 w-3.5 text-[#16A34A]" /> {label}
        </span>
      </span>
    ))}
  </div>
);
